var $ = jQuery;

function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

$(document).ready(function(){
    if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
     	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
     	isOnScreen($(".non-sticky-atc-button").eq(3)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(4)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(5)) || 
        isOnScreen($(".non-sticky-atc-button").eq(6)) || 
        isOnScreen($(".non-sticky-atc-button").eq(7)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(8)) || 
        isOnScreen($(".non-sticky-atc-button").eq(9)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(10)) || 
		isOnScreen($("#footer")) )   {
    	$(".sticky-atc-button").fadeOut(100);

  	} else {
    	$(".sticky-atc-button").fadeIn(100);
  	}
  
  	$(window).on('scroll',function(){
    	if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
	     	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
	     	isOnScreen($(".non-sticky-atc-button").eq(3)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(4)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(5)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(6)) || 
            isOnScreen($(".non-sticky-atc-button").eq(7)) || 
            isOnScreen($(".non-sticky-atc-button").eq(8)) || 
            isOnScreen($(".non-sticky-atc-button").eq(9)) || 
            isOnScreen($(".non-sticky-atc-button").eq(10)) || 
			isOnScreen($("#footer")) )   {
      		$(".sticky-atc-button").fadeOut(10);
      
    	} else {
     		$(".sticky-atc-button").fadeIn(10);
    	}
  	});	
    /* scroll to target */
    // jQuery('.scrollTo').click(function(e) {
    //     var jump = jQuery(this).attr('href');
    //     var new_position = jQuery(jump).offset();
    //     var scroll = 0;
    //     jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
    //         var new_position = jQuery(jump).offset();
    //         jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
    //     });
    //     e.preventDefault();
    // });


    // jsUSPBarSlider start here
    if($('.jsUSPBarSlider').length > 0){
        $('.jsUSPBarSlider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            variableWidth: true,
            prevArrow: '<button type="button" class="prev-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
		    nextArrow: '<button type="button" class="next-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        arrows: true,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        arrows: true,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        arrows: true,
                        variableWidth: false
                    }
                }
            ]
        });
    }    
    // jsUSPBarSlider End here

    // Header Menu css start here
    $(document).on('click', '.jsIconMenu', function() {
        $(this).parents('.cw-header__wrap').find('.cw-header__nav').addClass('open-sidebar');
        $(this).parents('.cw-header__wrap').find('.body-overlay').addClass('open');
        $('html').addClass('scroll-hide')
    });
    $(document).on('click', '.jsIconMenuClose', function() {
        $(this).parents('.cw-header__wrap').find('.cw-header__nav').removeClass('open-sidebar');
        $(this).parents('.cw-header__wrap').find('.body-overlay').removeClass('open');
        $('html').removeClass('scroll-hide')
    });
    $(document).on('click', '.mobiscroll', function() {
        $(this).parents('.cw-header__wrap').find('.cw-header__nav').removeClass('open-sidebar');
        $(this).parents('.cw-header__wrap').find('.body-overlay').removeClass('open');
        $('html').removeClass('scroll-hide')
    });
    $(document).on('click', '.body-overlay', function() {
        $(this).parents('.cw-header__wrap').find('.cw-header__nav').removeClass('open-sidebar');
        $(this).parents('.cw-header__wrap').find('.body-overlay').removeClass('open');
        $('html').removeClass('scroll-hide')
    });    
    // Header Menu css start here

    // client logo start here
    if ($('.jsClientLogoSlider').length > 0) {
        $('.jsClientLogoSlider').slick({
            speed: 3000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 6,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false
        });
    }
    // client logo start here

    // UGC video controll js Start here
    $(document).on("click", ".play-pause-icon-wrap", function () {
        var clickedVideo = $(this).parents('.collect-the-sample__content').find(".video-banner").get(0);

        $(".video-banner").not(clickedVideo).each(function () {
            this.pause();
            $(this).siblings('.play-pause-icon-wrap').find('.icon-play').show();
            $(this).siblings('.play-pause-icon-wrap').find('.icon-pause').hide();
        });

        if (clickedVideo.paused) {
            clickedVideo.play();
            clickedVideo.muted = false;
            $(this).find('.icon-play').hide();
            $(this).find('.icon-pause').show();
        } else {
            clickedVideo.pause();
            $(this).find('.icon-pause').hide();
            $(this).find('.icon-play').show();
        }
    });
    // UGC video controll js End here    

    // matchHeight js Start here
    $('.future-with-lifeplan__box h3').matchHeight({
        byRow: true,
    });
    $('.cw-v2-three-simple-steps__box h3').matchHeight({
        byRow: true,
    });    
    // matchHeight js End here

    $(function () {
        $('.js-accordian-title').click(function (j) {

            var dropDown = $(this).closest('.cw-v2-faq__cus-accordian-card').find('.cw-v2-faq__cus-accordian-panel');
            $(this).closest('.cw-v2-faq__cus-accordian').find('.cw-v2-faq__cus-accordian-panel').not(dropDown).slideUp();

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parents('.cw-v2-faq__cus-accordian-card').removeClass('active');
            } else {
                $(this).closest('.cw-v2-faq__cus-accordian').find('.cw-v2-faq__cus-accordian-title.active').removeClass('active');
                $(this).addClass('active');
                $(this).closest('.cw-v2-faq__cus-accordian').find('.cw-v2-faq__cus-accordian-card.active').removeClass('active');
                $(this).parents('.cw-v2-faq__cus-accordian-card').addClass('active');

            }

            dropDown.stop(false, true).slideToggle();
            j.preventDefault();
        });
    });
    // accordian js end here

     
    $(document).on("click", '.sale_atc',function(e){
        e.preventDefault();
        let varId = $(this).attr('data-id');
        let qty = $('.cw-v2-banner__qty').val();
        $.ajax({
            "url": "/cart/add.js",
            "method": "POST",
            "dataType": "JSON",
            "data": {
                id: varId,
                quantity: qty
            },
            "success": function(data) {
                window.location = "/checkout";
    
            },
            "error": function(data) {
                window.alert(data.responseJSON.description);
            }
        });
    });

    $(document).on('click', '.button-primary.sale_atc', function(){
        $(this).text('Adding...');
        $(this).parents('.pre-order-modal__content').find('.progress-bar-container').addClass('visible');
    }); 
    
 // Trusted By Dog Parents Everywhere
 if($(".js-our-customers-content-wrap").length > 0){
    $('.js-our-customers-content-wrap').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    arrows: true,
                }
            }
        ]
    });
}
// end Trusted By Dog Parents Everywhere
if ($('.js-cw-slide-for').length > 0) {
        $('.js-cw-slide-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          infinite: false,
          fade: true,
          prevArrow: '<button type="button" class="prev-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
          nextArrow: '<button type="button" class="next-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
          asNavFor: '.js-cw-slide-now',
        });
        $('.js-cw-slide-now').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.js-cw-slide-for',
            dots: false,
            arrows: false,
            infinite: false,
            speed: 900,
            focusOnSelect: true,
            centerMode: false,
        });
    } 
    if($('.js-cw-slide-now').find('.cw-slide-now__img').length < 6){
        $('.js-cw-slide-now').addClass('less-items');
    } else{
        console.log('Else');
        $('.js-cw-slide-now').removeClass('less-items');
    }

});